export default class Product {
  id: number;
  name: string;
  title: string;
  description: string;
  donation: number;
  duration: number;
  size: number;
  type: number;
  dharmamId: number;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/models/Product.ts